import { getDefaultLanguage } from "../actions/ui";
import { LANGUAGE, LOADING } from "../constants/ui";

const initialState = {
  loading: false,
  language: getDefaultLanguage(),
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        loading: action.payload,
      };
    case LANGUAGE:
      return {
        language: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;
